import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_Biq8SvWbdp7NGQWWVibrGieRruBJJWv2hrPVKLEZPyom';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

export function initAnalytics() {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname.startsWith('192.168.')) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_exceptions: true,
    persistence: 'memory',
  });
}

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties);
}

export function captureError(error: unknown, context?: Record<string, unknown>) {
  posthog.captureException(error, context);
}
